import React from "react";
import Folder from "../components/Folder";
import TitleSection from "../components/TitleSection";
import { fileUrl } from "../Tools/APIs/useMyAPI";

const Sections = ({ data }) => {
  let dataAllSection = data?.data?.data?.sections;

  console.log(data);

  return (
    <div id="sections" className="flex flex-col w-[90%] mx-auto ">
      <TitleSection title="اقسامنا" desc={""} />
      <div className="grid grid-cols-2 md:grid-cols-4 flex w-full">
        {dataAllSection?.data?.map((e) => (
          <>
            <Folder
              icon={fileUrl + e.image}
              title={e.name}
              desc={e.description}
            />
          </>
        ))}
      </div>
    </div>
  );
};

export default Sections;
